export function drawFooter(doc, month, year, title) {
  const pages = doc.internal.getNumberOfPages();

  for (let i = 1; i <= pages; i++) {
    doc.setPage(i);

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    const isPortrait = pageHeight > pageWidth;

    doc.setTextColor(0);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(isPortrait ? 7 : 8);

    // Footer title
    // doc.text(
    //   `${title} for the month of ${month} - ${year}`,
    //   10,
    //   pageHeight - 5
    // );


const now = new Date();

const currentDateTime = now.toLocaleString("en-IN", {
  day: "2-digit",
  month: "short",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  hour12: true,
});

doc.text(
  `${title} | Generated: ${currentDateTime}`,
  10,
  pageHeight - 5
);


    // Page number
    doc.text(
      `Page ${i} of ${pages}`,
      pageWidth - 10,
      pageHeight - 5,
      { align: "right" }
    );
  }
}